function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.75 2C0.75 1.30964 1.30964 0.75 2 0.75H47C47.3315 0.75 47.6495 0.881696 47.8839 1.11612L72.8839 26.1161C73.1183 26.3505 73.25 26.6685 73.25 27V92C73.25 92.6904 72.6904 93.25 72 93.25H2C1.30964 93.25 0.75 92.6904 0.75 92V2ZM3.25 3.25V90.75H70.75V33.25H52C45.7868 33.25 40.75 28.2132 40.75 22V3.25H3.25ZM43.25 3.25V22C43.25 26.8325 47.1675 30.75 52 30.75H70.75V27.5178L46.4822 3.25H43.25ZM15.75 52C15.75 51.3096 16.3096 50.75 17 50.75H47C47.6904 50.75 48.25 51.3096 48.25 52C48.25 52.6904 47.6904 53.25 47 53.25H17C16.3096 53.25 15.75 52.6904 15.75 52ZM15.75 72C15.75 71.3096 16.3096 70.75 17 70.75H57C57.6904 70.75 58.25 71.3096 58.25 72C58.25 72.6904 57.6904 73.25 57 73.25H17C16.3096 73.25 15.75 72.6904 15.75 72Z",
  fill: "#111826"
});

function SvgFileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 94,
    viewBox: "0 0 74 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/FileIcon.22f46ea2ac6e41c26b01f5db4a6bf17f.svg";
export { ForwardRef as ReactComponent };